import { SibBaseObject } from "../BaseObject/SibBaseObject";
import { Country } from "./country";

export class State extends SibBaseObject {
    country: Country = new Country();
    name: string;
    code: string;
    key: string;
}
